var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToiletPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M50.18 20.37c0 10.4-4.86 18.818-10.868 18.818H13.276v12.38l3.075-2.607 3.076 2.606 3.075-2.606 3.075 2.606 3.076-2.606 3.075 2.606 3.075-2.606 3.076 2.606 3.075-2.606 3.076 2.606 3.075-2.606 3.075 2.606V20.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M28.457 20.37c0-10.398 4.847-18.817 10.842-18.83H12.207v.013c-.117 0-.235-.013-.352-.013C5.861 1.54 1 9.972 1 20.37c0 10.4 4.86 18.818 10.868 18.818.117 0 .235 0 .352-.013v.013h1.069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.288 39.188h25.893c-5.929-.13-10.724-8.51-10.724-18.818M50.18 20.37c0-10.398-4.861-18.817-10.869-18.817h-.013.013M39.312 12.539c1.76 0 3.18 3.505 3.18 7.832M39.312 39.188h-.143.143Zm0 0c5.995 0 10.868-8.419 10.868-18.818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M42.492 20.37c0 4.327-1.42 7.832-3.18 7.832M36.132 20.37c0-4.326 1.42-7.831 3.18-7.831M39.312 1.54H39.3c-5.994.013-10.842 8.432-10.842 18.83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39.312 28.19c-1.76 0-3.18-3.506-3.18-7.832M28.457 20.37c0 10.308 4.782 18.687 10.725 18.818h.143M42.492 20.37c0-4.326-1.42-7.831-3.18-7.831"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    className: "stroke",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39.312 28.19c1.76 0 3.18-3.506 3.18-7.832M39.312 12.539c-1.76 0-3.18 3.505-3.18 7.832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletPaper);
export default __webpack_public_path__ + "static/media/toilet-paper.7eb94781.svg";
export { ForwardRef as ReactComponent };